import { DashboardAPI } from '@/api'

export const OnLoadStore = {
  namespaced: true,
  state: {
    data: {},
    loaded: false,
  },
  mutations: {
    saveData(state, data) {
      state.data = { ...state.data, ...data };
    },
    load(state) {
      state.loaded = true;
    },
  },
  actions: {
    async updateData({ commit }) {
    
      const arr = await Promise.all([
        DashboardAPI.selectAllHubstaffProjects().then(res => ({
          key: 'hs-projects',
          data: res.data,
        })),

        DashboardAPI.selectAllHubstaffMembers().then(res => ({
          key: 'hs-members',
          data: res.data,
        })),
      ]);

      const data = {};
      arr.forEach(n => {
        data[n.key] = n.data;
      });
      
      commit('saveData', data);
      commit('load');
    }
  },
  getters: {
    isLoaded(state) {
      return state.loaded;
    },
    data: state => key => {
      return state.data[key];
    },
  }
};
